import React from 'react';
export function Urgency() {
  return <section aria-labelledby="urgency-heading" className="w-full bg-ink" data-id="element-221" data-mp="jij3cenrinv5">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-20 sm:py-24 text-center" data-id="element-222" data-mp="2bvmn09v055tj">
        <p className="text-[13px] font-semibold uppercase tracking-kicker text-sage" data-id="element-223" data-mp="1x06nhpbnkhpr">
          The only deadline that matters is yours
        </p>

        <h2 id="urgency-heading" className="mt-5 font-serif font-normal text-white text-[28px] sm:text-[40px] leading-tight" data-id="element-224" data-mp="220kxhcwte1qf">
          Every month you wait is a volume you don&apos;t get to use.
        </h2>

        <p className="mt-8 text-[17px] sm:text-[18px] leading-[1.6] text-white/75" data-id="element-225" data-mp="1e9fiezyp7dh6">
          This isn&apos;t a limited-time offer — it&apos;s a limited-time
          product. Buy it eleven months out and you get all six volumes. Buy it
          three months out and Volumes 1 and 2 are already behind you.
        </p>

        <p className="mt-8 font-serif italic text-sage text-[26px] sm:text-[32px] leading-snug" data-id="element-226" data-mp="198rfph13x874">
          The plan doesn&apos;t expire. Your runway does.
        </p>
      </div>
    </section>;
}